import { gql } from '@apollo/client/core';

export const TRANSCRIPT_TYPE_FIELDS = gql`
  fragment TranscriptTypeFields on TranscriptType {
    id
    name
    slug
    description
    category
    is_active
    metadata
    created_at
    updated_at
    billItemTemplate {
      id
      name
      default_amount
      billItemCategory {
        id
        name
      }
    }
  }
`;

export const TRANSCRIPT_ACTIVITY_FIELDS = gql`
  fragment TranscriptActivityFields on TranscriptRequestActivity {
    id
    transcript_request_id
    type
    content
    old_status
    new_status
    is_visible_to_applicant
    metadata
    created_at
    user {
      id
      name
    }
  }
`;

export const GENERATED_TRANSCRIPT_FIELDS = gql`
  fragment GeneratedTranscriptFields on GeneratedTranscript {
    id
    transcript_request_id
    student_id
    data
    summary
    version
    generated_at
    file_path
    cover_letter
    metadata
    transcript_template_id
    transcriptTemplate {
      id
      name
      style_code
    }
    created_at
    generatedBy {
      id
      name
    }
  }
`;

export const TRANSCRIPT_TEMPLATE_FIELDS = gql`
  fragment TranscriptTemplateFields on TranscriptTemplate {
    id
    name
    style_code
    properties
    programmes {
      id
      program_name
      degree
    }
    created_at
    updated_at
  }
`;

export const TRANSCRIPT_REQUEST_FIELDS = gql`
  fragment TranscriptRequestFields on TranscriptRequest {
    id
    transcript_type_id
    student_id
    programme_id
    tracking_code
    applicant_category
    applicant_name
    applicant_email
    applicant_phone
    matric_no
    student_status
    supporting_document_path
    supporting_document_name
    supporting_document_url
    programme_name
    year_of_admission
    year_of_graduation
    destination_address
    destination_institution
    recipient_email
    courier_name
    courier_address
    courier_phone
    platform_name
    platform_code
    number_of_copies
    status
    rejection_reason
    complaint_note
    submitted_at
    processed_at
    approved_at
    collected_at
    admin_notes
    created_at
    updated_at
    transcriptType {
      id
      name
      category
    }
    student {
      id
      first_name
      surname
      other_name
      matric_no
      email
    }
    approvedBy {
      id
      name
    }
  }
`;
